/*
 * Stub for developing and rendering the page. Prefer modifying the story component instead.
 */
import { default as Layout } from "@stories/data-centers-hub";
import { getStaticProps } from "@stories/data-centers-hub/get-static-props";

export default Layout;
export { getStaticProps };
